export default "__VITE_ASSET__B1OEoZ2o__"